// extracted by mini-css-extract-plugin
module.exports = {"option":"Checkboxes__option___112v8","input":"Checkboxes__input___Pi8jJ","label":"Checkboxes__label___1_-c4"};